
import DataTable from "react-data-table-component";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { UserListTableData } from "../../data/users/UsersList";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { tableHeaderStyles } from "../../styles/ReactSelectStyles";
import { LoginFailureReportTable } from "../../data/users/LoginFailureReport";

function LoginFailuresReport() {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t("LoginFailures")} parent={t("Reports")} parentLink={`${process.env.PUBLIC_URL}/reports`} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
              <div className="list-product">
              <div className="table-responsive">
                <DataTable
                  data={UserListTableData}
                  columns={LoginFailureReportTable(t)}
                  striped
                  pagination
                  subHeader
                  pointerOnHover
                  customStyles={tableHeaderStyles}
                  highlightOnHover
                  noDataComponent={
                    <div className="text-center p-4 text-muted">
                      {t("NoActivityhistoryMessage")}
                    </div>
                  }
                />
                </div></div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LoginFailuresReport;
